import defaultAttributes from '../defaultAttributes';

const Umbrella = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7' }]],
];

export default Umbrella;
